import { ICON_BASE_PATH } from "@/app/utils/config";
import { gxCurrencyFormat } from "@/app/utils/helpers/gxCurrencyFormat";
import "./DirectDebitScreen.scss";
import { memo } from "react";
import type { DirectDebitAccount } from "@/app/types/accounts";

interface AccountSelecttionDropdownProp {
  onClick: () => void;
  selectedAccount: DirectDebitAccount | undefined;
}
const AccountSelecttionDropdown = memo(
  ({ onClick, selectedAccount }: AccountSelecttionDropdownProp) => {
    const maskAccountNumber = (accountNumber: string): string => {
      // Ensure we only show the last 4 digits
      const lastFour = accountNumber.slice(-4);
      return `****${lastFour}`;
    };

    return (
      <div className="gx-account-selection-dropdown-wrapper">
        <button onClick={onClick} className="gx-account-selection-dropdown">
          <div className="gx-account-selection-dropdown-bank-info-wrapper">
            <div className="gx-account-selection-dropdown-bank-icon-wrapper">
              <img
                className="gx-account-selection-dropdown-bank-icon"
                src={`${ICON_BASE_PATH}bank-icon-white.svg`}
                alt="bank-icon"
              />
            </div>
            {selectedAccount ? (
              <div className="gx-account-selection-dropdown-bank-info">
                <h4 className="gx-p14-sb">
                  {selectedAccount.accountName}{" "}
                  <span>{maskAccountNumber(selectedAccount.accountNo)}</span>
                </h4>
                <p className="gx-p12-r">
                  {
                    gxCurrencyFormat(
                      selectedAccount.accountAvailBalance,
                      selectedAccount?.accountCurrencyCode,
                    ).symbol
                  }{" "}
                  {
                    gxCurrencyFormat(
                      selectedAccount.accountAvailBalance,
                      selectedAccount?.accountCurrencyCode,
                    ).integer
                  }
                  {
                    gxCurrencyFormat(
                      selectedAccount.accountAvailBalance,
                      selectedAccount?.accountCurrencyCode,
                    ).decimal
                  }{" "}
                  (Available Balance)
                </p>
              </div>
            ) : (
              <div className="gx-account-selection-dropdown-bank-info">
                <div className="gx-account-selection-dropdown-bank-info-placeholder">
                  <span className="gx-p14-sb">Select Debit Account</span>
                </div>
              </div>
            )}
          </div>
          <img
            src={`${ICON_BASE_PATH}down_arrow1.svg`}
            alt="Down Arrow"
            className={"gx-account-selection-dropdown-arrow-down"}
          />
        </button>
      </div>
    );
  },
);

export default AccountSelecttionDropdown;
